interface HistoryGapMarkerProps {
  dataStartDate: string;
}

export function HistoryGapMarker({ dataStartDate }: HistoryGapMarkerProps) {
  const formatted = new Date(dataStartDate + "T00:00:00").toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return (
    <div
      className="px-3 py-2.5 space-y-1.5 text-xs text-muted-foreground/60"
      data-testid="history-gap-marker"
    >
      <div className="border-t border-dashed border-muted-foreground/20" />
      <p className="italic text-center">
        BETI records begin {formatted} — earlier history not captured
      </p>
    </div>
  );
}
